export function formatDate(iso, opts = {}) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", ...opts });
}

export function formatTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
}

export function formatDay(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
}

export function relativeBucket(iso) {
  if (!iso) return null;
  const target = new Date(iso); target.setHours(0,0,0,0);
  const today = new Date(); today.setHours(0,0,0,0);
  const diff = Math.round((target - today) / 86400000);
  if (diff < 0) return "Past";
  if (diff === 0) return "Today";
  if (diff === 1) return "Tomorrow";
  if (diff < 7) return "This week";
  return "Later";
}

export function classFor(priority) {
  if (priority === "Critical") return "bg-[var(--fcc-red-soft)] text-[#8B241D]";
  if (priority === "Important") return "bg-[#FCE4CF] text-[#9A4D14]";
  return "bg-[var(--fcc-green-soft)] text-[var(--fcc-green)]";
}

export function categoryIcon(category) {
  switch (category) {
    case "School": return "GraduationCap";
    case "Sports": return "Trophy";
    case "Camp": return "Tent";
    case "Activity": return "Music";
    case "Appointment": return "Stethoscope";
    case "Payment": return "Wallet";
    case "Form": return "FileSignature";
    case "Transportation": return "Bus";
    case "Event": return "PartyPopper";
    default: return "Sparkles";
  }
}

export function childChip(name) {
  if (!name) return "bg-[var(--fcc-cream-2)] text-[var(--fcc-green)]";
  if (name.toLowerCase().includes("emma")) return "bg-[var(--fcc-emma)] text-[var(--fcc-green)]";
  if (name.toLowerCase().includes("noah")) return "bg-[var(--fcc-noah)] text-[var(--fcc-green)]";
  return "bg-[var(--fcc-cream-2)] text-[var(--fcc-green)]";
}
